/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable react/no-danger */
import React from 'react'
import Image from 'next/image'
import { healthWidgetIconConfig } from '@components/Product/ProductWidget/subComponents/ProductHealthInfoCard/healthWidgetConfig'
import { getCtaWidgetPurpleLayout, getpurpleRootContainerLayout } from '@configs/productWidget.config'
import { getClassNames, getDynamicHeadingTag } from '@helpers/productWidgetHelper'
import { ProductWidgetHeaderProps, HeroImageProps } from './productInterfaces'
import styles from '../productWidget.module.scss'

const HeroImage: React.FC<HeroImageProps> = ({ imageUrl, width, height, alt, className }) => (
  <Image src={imageUrl} alt={alt} width={width} height={height} className={className} priority />
)

const HealthWidgetIcon: React.FC<{ position: 'left' | 'right' }> = ({ position }) => {
  const config = healthWidgetIconConfig[position]

  return (
    <div className={styles[config.className]}>
      <Image
        src={`https://acko-seo-prod.ackoassets.com/_next_static/images/${config.imagePath}`}
        alt={`product Health widget ${position} plus icon`}
        width={config.width}
        height={config.height}
        priority
      />
    </div>
  )
}

const renderHeading = (props: ProductWidgetHeaderProps) => {
  const { isSeoCarWidget, isHealthWidgetPurpleLayout, content, THEME_CONFIG } = props

  const headingTag = getDynamicHeadingTag(content?.widget, isSeoCarWidget, isHealthWidgetPurpleLayout)

  const headingContainerClassNames = getClassNames([styles.newLayoutHeading], {
    [styles.boldHeading]: getCtaWidgetPurpleLayout[content?.widget],
  })

  const newHeadingContainerClassNames = getClassNames([styles.newLayoutHeading], {
    [styles.boldHeadingMweb]: getpurpleRootContainerLayout[content?.widget],
  })

  const classNames = isSeoCarWidget
    ? `${newHeadingContainerClassNames} ${THEME_CONFIG[content?.theme || '']}`
    : isHealthWidgetPurpleLayout
      ? styles.healthWidgetMainHeading
      : `${headingContainerClassNames} ${THEME_CONFIG[content?.theme || '']}`

  return React.createElement(headingTag, { className: classNames }, content?.productWidgetMainHeading)
}

const renderSubHeading = (props: ProductWidgetHeaderProps) => {
  const { isSeoCarWidget, isHealthWidgetPurpleLayout, content, THEME_CONFIG } = props

  const subHeadingContainerClassNames = getClassNames([styles.subHeading], {
    [styles.lighterSubHeading]: getCtaWidgetPurpleLayout[content?.widget],
  })

  if (isSeoCarWidget) {
    return (
      <div
        className={styles.subHeadingWithLineBreak}
        dangerouslySetInnerHTML={{ __html: content?.ProductWidgetSubHeading || '' }}
      />
    )
  }

  if (isHealthWidgetPurpleLayout) {
    return <p className={styles.healthWidgetMainSubHeading}>{content?.ProductWidgetSubHeading}</p>
  }

  return (
    <p className={`${subHeadingContainerClassNames} ${THEME_CONFIG[content?.theme || '']}`}>
      {content?.ProductWidgetSubHeading}
    </p>
  )
}

// Main Function
const ProductWidgetHeader: React.FC<ProductWidgetHeaderProps> = props => {
  const { content, isSeoCarWidget, isHealthWidgetPurpleLayout = false } = props
  const mobileImageUrl = content?.productWidgetHeroImageMobile?.data?.attributes?.url
  const desktopImageUrl = content?.productWidgetHeroImageDesktop?.data?.attributes?.url

  return (
    <>
      {/* Non-SEO Car Widget Mobile Hero Image */}
      {!isSeoCarWidget && mobileImageUrl && (
        <HeroImage
          imageUrl={mobileImageUrl}
          width={190}
          height={190}
          alt="product widget Hero image mobile"
          className={styles.semHeroImageMweb}
        />
      )}

      {/* Health Widget Desktop Hero Image */}
      {isHealthWidgetPurpleLayout && desktopImageUrl && (
        <HeroImage
          imageUrl={desktopImageUrl}
          width={292}
          height={248}
          alt="product widget Hero image desktop"
          className={styles.semHeroImageWeb}
        />
      )}

      {/* Health Widget Icons */}
      {isHealthWidgetPurpleLayout && (
        <>
          <HealthWidgetIcon position="left" />
          <HealthWidgetIcon position="right" />
        </>
      )}

      {renderHeading(props)}
      {renderSubHeading(props)}
    </>
  )
}

export default ProductWidgetHeader
